import { render, staticRenderFns } from "./AgreementCustomFields.vue?vue&type=template&id=1485a6c9&scoped=true&"
import script from "./AgreementCustomFields.vue?vue&type=script&lang=js&"
export * from "./AgreementCustomFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1485a6c9",
  null
  
)

export default component.exports